/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { IObservation } from '@ahryman40k/ts-fhir-types/lib/R4/Resource';

type FhirWidgetRangeTooltipProps = {
  codeText?: string;
  observation: IObservation | undefined;
  observationLabel: string;
};

export function FhirWidgetRangeTooltip({ codeText, observation, observationLabel }: FhirWidgetRangeTooltipProps) {
  return (
    <span>
      <u>
        <b>{observationLabel}</b>
      </u>
      <br />
      <br />
      {codeText}
      <br />
      <br />
      {observation?.referenceRange?.map((referenceRange, index) => (
        <div key={index}>
          Reference: {referenceRange.text || `${referenceRange.low?.value} - ${referenceRange.high?.value}`}
        </div>
      ))}
      {observation?.interpretation?.map((interpretation, index) => (
        <div key={index}>Interpretation: {interpretation.text}</div>
      ))}
    </span>
  );
}
